import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../utils/redux';
import { setCurrentStep } from '../../../utils/redux/slices/signupSlice';

import CommonAuthLayout from '../CommonAuthLayout';
import CreateAccount from './CreateAccount';
import ProfileBusinessInfo from './Profile&BusinessInfo';
import RegisteredLocation from './RegisteredLocation';

const SignUpJourney: React.FC = () => {
  const dispatch = useDispatch();
  const { currentStep } = useSelector((state: RootState) => state.signup);

  // Reset to step 1 when component mounts
  useEffect(() => {
    dispatch(setCurrentStep(1));
  }, [dispatch]);

  // Render the appropriate step based on currentStep
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <CreateAccount />;
      case 2:
        return <ProfileBusinessInfo />;
      case 3:
        return <RegisteredLocation />;
      default:
        return <CreateAccount />;
    }
  };

  return <CommonAuthLayout>{renderStep()}</CommonAuthLayout>;
};

export default SignUpJourney;
